import store from './store'
import momentTimezone from 'moment-timezone'

/*** Will be removed after complete timezone implementation */
export const dateEST = date => {
  const d = date ? new Date(date) : new Date()
  const utc = d.getTime() + d.getTimezoneOffset() * 60000
  const estOffset = momentTimezone(d)
    .tz('America/Toronto')
    .utcOffset()
  return new Date(utc + 60000 * estOffset)
}

export const dateViaTZ = date => {
  const currentTimezone =
    store.state.auth.preferences.timezone_offset !== undefined
      ? store.state.auth.preferences.timezone_offset 
      : -4
  const d = date ? new Date(date) : new Date()
  const utc = d.getTime() + d.getTimezoneOffset() * 60000
  return new Date(utc + 3600000 * currentTimezone)
}

export const errorMessage = errors => {
  if (typeof errors === "object" && !Array.isArray(errors)) {
    return Object.keys(errors)
      .map((key, index) => {
        let message =
          key !== "base"
            ? `${key.replace(/_/g, " ")} ${errors[key]}`
            : `${errors[key]}`;

        message = message[0].toUpperCase() + message.substring(1);
        return Object.keys(errors).length > 1
          ? `${index + 1}) ${message}`
          : message;
      })
      .join(", <br/>");
  }
};
